import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Landmark, FileCheck2, Wrench, Phone } from "lucide-react";
import { partners, img } from "../mock";
import Seo from "../components/Seo";

const Partners = () => {
  useEffect(() => {
    const obs = new IntersectionObserver((es) => es.forEach((e) => e.isIntersecting && e.target.classList.add("in")), { threshold: 0.1 });
    document.querySelectorAll(".mh-reveal").forEach((el) => obs.observe(el));
    return () => obs.disconnect();
  }, []);

  return (
    <div>
      <Seo
        title="Our Partners"
        description="Monarch Homes of Brevard works with a trusted network of lenders, title services and craftsmen, including US Bank and Aurora Title, to build your custom home."
        keywords="Monarch Homes partners, Aurora Title Melbourne FL, home builder lenders Brevard County"
        path="/partners"
      />
      <section className="mh-page-hero" style={{ backgroundImage: `url(${img.ext2})` }}>
        <div className="mh-page-hero-inner">
          <div className="mh-crumb"><Link to="/">Home</Link> / Partners</div>
          <h1>Our Partners</h1>
        </div>
      </section>

      <section className="mh-section">
        <div className="mh-container">
          <div className="mh-section-head mh-reveal">
            <div className="mh-eyebrow">Trusted Relationships</div>
            <h2>The Team Behind Every Monarch Home</h2>
            <p>{partners.intro}</p>
            <div className="mh-divider" />
          </div>

          <div className="mh-grid-2" style={{ marginBottom: 30 }}>
            <div className="mh-partner-feature mh-reveal">
              <div className="mh-partner-ic"><Landmark size={26} /></div>
              <div>
                <span className="mh-partner-label">{partners.lender.label}</span>
                <h3>{partners.lender.name}</h3>
              </div>
            </div>
            <div className="mh-partner-feature mh-reveal">
              <div className="mh-partner-ic"><FileCheck2 size={26} /></div>
              <div>
                <span className="mh-partner-label">{partners.title.label}</span>
                <h3>{partners.title.name}</h3>
                <a href={`tel:${partners.title.phone.replace(/[^0-9]/g, "")}`} className="mh-partner-phone"><Phone size={14} /> {partners.title.phone}</a>
              </div>
            </div>
          </div>

          <div className="mh-trades mh-reveal">
            <div className="mh-trades-head"><Wrench size={20} /> <h3>Subcontractors &amp; Suppliers</h3></div>
            <div className="mh-trades-grid">
              {partners.trades.map((t, i) => (
                <div key={i} className="mh-trade-item">{t}</div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Partners;
